export default __webpack_public_path__ + "static/stephen-kao-0407be1381cebac7cdb44a8bf97cca1a.jpg";